import React, { useState } from 'react'
import classNames from 'classnames'
import { RichText } from '~/components/contentful/ContentfulRichText'
import { IconSizes } from '@reward-platform/lift/theme/iconSize'
import { Icon } from '@reward-platform/lift/components/Icon'
import { Document } from '@contentful/rich-text-types'
import { Heading } from '@alto-avios/alto-ui'
import styles from './AccordionItem.module.scss'

interface AccordionItemProps {
  id: string
  title: string
  content: Document
}

const AccordionItem = (props: AccordionItemProps) => {
  const { title, content, id } = props
  const [isExpanded, setIsExpanded] = useState(false)

  return (
    <div className={styles.accordionItem}>
      <Heading as="h2" size="xs" foregroundColor="accentSecondary">
        <button
          id={`accordion-button-${id}`}
          type="button"
          className={classNames(styles.accordionButton, isExpanded && styles.expanded)}
          onClick={() => setIsExpanded((prev) => !prev)}
          aria-expanded={isExpanded}
          aria-controls={`accordion-panel-${id}`}
        >
          {title}
          <Icon iconName="down-chevron" width={IconSizes.xxs} className={styles.accordionIcon} />
        </button>
      </Heading>
      <div
        id={`accordion-panel-${id}`}
        className={classNames(styles.accordionPanel, isExpanded && styles.expanded)}
        hidden={!isExpanded}
        role="region"
        aria-labelledby={`accordion-button-${id}`}
      >
        <RichText document={content} openLinksInNewTab sizes={{ h2: 'xs', h3: 'xs', h4: 'xs' }} />
      </div>
    </div>
  )
}

export default AccordionItem
